export const ALLIANCE_BENEFIT_BUILDING_OPTIONS = Object.freeze([
  {
    id: 17039423,
    label: "Army Factory",
    sourceKey: "Wild_ArmyFactory",
    effects: [
      { effectId: 50397254, value: 20 },
      { effectId: 50397279, value: 20 },
      { effectId: 50397255, value: 20 },
    ],
  },
  {
    id: 17039424,
    label: "Hospital",
    sourceKey: "Wild_Hospital",
    effects: [
      { effectId: 50397205, value: 20 },
      { effectId: 50397207, value: 40 },
    ],
  },
  {
    id: 17039425,
    label: "Lab",
    sourceKey: "Wild_Lab",
    effects: [
      { effectId: 50397244, value: 20 },
      { effectId: 50397284, value: 40 },
    ],
  },
  {
    id: 17039426,
    label: "Motor Factory",
    sourceKey: "Wild_Moto",
    effects: [
      { effectId: 50397221, value: 20 },
      { effectId: 50397283, value: 40 },
    ],
  },
]);

export const ALLIANCE_BENEFIT_BUILDING_BY_ID = new Map(
  ALLIANCE_BENEFIT_BUILDING_OPTIONS.map((row) => [Number(row.id), row]),
);

export const getAllianceBenefitBuildingOption = (id = 0) => (
  ALLIANCE_BENEFIT_BUILDING_BY_ID.get(Math.trunc(Number(id || 0))) || null
);
